// @flow

import React, { type Node } from 'react';
import { connect } from 'react-redux';
import { routeTo } from 'redux-router-kit';
import bemify from 'bemify-js';

import { Invitation } from '@zapier/authentication';
import { RouterSelectors } from '@zapier/toolbox-redux-framework';

import LoadingBlock from 'app/common/components/LoadingBlock';
import WithInvitationByCode from 'app/login/components/WithInvitationByCode';
import 'app/login/components/ZapierIdentityAuth/ZapierAuthentication.scss';
import { PLATFORM_PATH_RE } from 'app/login/constants';

const bem = bemify('zapier-authentication');

type AuthenticationContainerChildrenProps = {
  isPlatformPage: Boolean,
  queryParameters: Object,
  routeTo: Function,
  invitation: ?Invitation,
};

type Props = {
  children: AuthenticationContainerChildrenProps => Node,
  isPlatformPage: Boolean,
  queryParameters: Object,
  routeTo: Function,
};

const mapStateToProps = state => {
  return {
    isPlatformPage: PLATFORM_PATH_RE.test(
      RouterSelectors.getCurrentPathname(state)
    ),
    queryParameters: RouterSelectors.getQueryParams(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    routeTo(...params) {
      dispatch(routeTo(...params));
    },
  };
};

const ZapierAuthenticationContainer = (props: Props) => {
  const { queryParameters } = props;
  const invitationCode = queryParameters.invitation;

  return (
    <WithInvitationByCode code={invitationCode}>
      {({ isLoading: isInvitationLoading, invitation }) => {
        if (isInvitationLoading) {
          return <LoadingBlock />;
        }

        const childProps: AuthenticationContainerChildrenProps = {
          isPlatformPage: props.isPlatformPage,
          queryParameters: props.queryParameters,
          routeTo: props.routeTo,
          invitation,
        };
        return <div className={bem()}>{props.children(childProps)}</div>;
      }}
    </WithInvitationByCode>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ZapierAuthenticationContainer);
